/**
 * Bind action to search button
 *
 * @returns {void}
 */
export default class Search {
  /**
   * Constructor
   *
   * @returns {void}
   */
  constructor() {
    // Set scope
    const scope = document.body;

    this.boundOpenSearch = (e) => this.openSearch(e);
    this.boundCloseSearch = (e) => this.closeSearch(e);

    // Get elements
    this.input = scope.querySelector(".search-input ");
    this.searchButton = scope.querySelector(".search-button");

    this.init();
  }

  /**
   * Add event listeners
   *
   * @returns {void}
   */
  init() {
    if (this.searchButton) {
      // Toggle search show on button click
      this.searchButton.addEventListener("click", this.boundOpenSearch, true);
      document.addEventListener("click", this.boundCloseSearch, true);
    }
  }

  /**
   * Bind action to search element
   *
   * @param {ClickEvent} e - Event from the click listener
   *
   * @returns {void}
   */
  openSearch(e) {
    if (this.input.classList.contains("show-search-input")) return; // Submit the form if the menu is open aka don't prevent default.

    e.preventDefault(); // Prevent the form submit.

    this.input.classList.add("show-search-input"); // Toggle the search input.
    this.searchButton.classList.add("show-search-input");
  }

  /**
   * Bind action to search element
   *
   * @param {ClickEvent} e - Event from the click listener
   *
   * @returns {void}
   */
  closeSearch(e) {
    if (e.target === this.input || e.target === this.searchButton) return; // Return when the search input or button are clicked.

    this.input.classList.remove("show-search-input"); // Close the input.
    this.searchButton.classList.remove("show-search-input"); // Toggle the search button color.
  }
}
